import React, { FC } from "react";
import { RHRHeaderProps } from "container-rhr-header/types";
import memoize from "utils/memoize";
import HeaderSwitcher from "containers/HeaderSwitcher";
export interface HeaderSwitcherProps {
  RHRHeaderProps?: RHRHeaderProps;
}

export const GlobalHeader: FC<HeaderSwitcherProps> = props => {
  return <HeaderSwitcher {...props} isAem={true} />;
};

export default memoize(GlobalHeader);
